import Text from './text'
import Graphic from './graphic'

// Area Class
export default class {
  constructor (config = {}) {
    this.manifest = {}
    // Guard on truthiness so an undefined manifest doesn't clobber the {} default.
    if (config.manifest) {
      this.manifest = config.manifest
    }

    this.label = ''
    this.areaIndex = null
    this._path = null
    this.texts = []
    this.graphics = []

    let defaults = {}
    try {
      defaults = config.defaults
    } finally {}

    if (config.hasOwnProperty('areaObj')) {
      this.fromObject(config.areaObj, defaults)
    }
  }

  fromObject (obj, defaults = {}) {
    // Required fields
    this.areaIndex = obj.areaIndex
    if (typeof this.areaIndex === 'undefined') {
      this.areaIndex = obj.areas_index
    }

    this._path = `customization.areas.${this.areaIndex}`

    // Label
    try {
      this.label = obj.label
    } finally {}

    // Texts
    if (obj.hasOwnProperty('texts')) {
      if (obj.texts.length > 0) {
        for (let i = 0; i < obj.texts.length; i++) {
          let textConfig = {
            manifest: this._getTextManifest(i),
            defaults,
            textObj: Object.assign({
              areaIndex: this.areaIndex,
              areaLabel: this.label,
              textIndex: i
            }, obj.texts[i])
          }
          let text = new Text(textConfig)
          this.texts.push(text)
        }
      }
    }

    // Graphics
    if (obj.hasOwnProperty('graphics')) {
      if (obj.graphics.length > 0) {
        for (let i = 0; i < obj.graphics.length; i++) {
          let graphic = obj.graphics[i]
          let graphicConfig = {
            manifest: this._getGraphicManifest(i),
            defaults,
            graphicObj: Object.assign({
              areaIndex: this.areaIndex,
              areaLabel: this.label,
              graphicIndex: i
            }, graphic)
          }
          let newGraphic = new Graphic(graphicConfig)
          this.graphics.push(newGraphic)
        }
      }
    }
  }
  _getTextManifest (textIndex) {
    try {
      return this.manifest.texts[textIndex]
    } catch (e) {
      throw new Error(`Unable to get the text manifest for areaIndex:${this.areaIndex} textIndex:${textIndex}`)
    }
  }
  _getGraphicManifest (graphicIndex) {
    try {
      return this.manifest.graphics[graphicIndex]
    } catch (e) {
      throw new Error(`Unable to get the text manifest for areaIndex:${this.areaIndex} graphicIndex:${graphicIndex}`)
    }
  }

  getPostData () {
    let me = {
      'label': this.label,
      'areas_index': this.areaIndex
    }

    me.texts = []
    this.texts.forEach(text => me.texts.push(text.getPostData()))

    me.graphics = []
    this.graphics.forEach(graphic => me.graphics.push(graphic.getPostData()))

    return me
  }
}
